import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate, useRemoveQueryParams } from 'js/hooks/navigate';
import { useIsAllowedToRedirect } from 'js/hooks/useIsAllowedToRedirect';

export const useAfterCredentialsLoginAction = () => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const removeQueryParams = useRemoveQueryParams();
    const isAllowedToRedirect = useIsAllowedToRedirect();
    const searchParams = new URLSearchParams(search);
    const loginAction = searchParams.get('login_action');

    let path = '';

    if (loginAction) {
        path = searchParams.get(loginAction) || loginAction;
        path = path
            .replace(/preferedmode=offline/, 'preferedmode=real')
            .replace(/real=0/, 'real=1');
    }

    return useCallback(() => {
        removeQueryParams(['login_action', loginAction]);

        if (!path || !isAllowedToRedirect(path)) {
            return;
        }

        navigate(path);
    }, [
        path, loginAction, isAllowedToRedirect,
        navigate, removeQueryParams
    ]);
};
